import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ListPaneType} from '../../enums/list-pane-type.enum';

@Component({
  selector: 'awair-grid-floor-toggle',
  templateUrl: './grid-floor-toggle.component.html',
  styleUrls: ['./grid-floor-toggle.component.scss']
})

export class GridFloorToggleComponent implements OnInit {

  get selectedListPane(): ListPaneType {
    if (this._selectedListPane != null) {
      return this._selectedListPane;
    }
  }
  @Input()
  set selectedListPane(value: ListPaneType) {
    if (value != null) {
      this._selectedListPane = value;
      [this.gridColor, this.floorColor] = value === ListPaneType.Grid ? ['#64C2E6', '#ACB4BB'] : ['#ACB4BB', '#64C2E6'];
    }
  }
  private _selectedListPane: ListPaneType = ListPaneType.Grid;

  @Output() selectedItem: EventEmitter<ListPaneType> = new EventEmitter<ListPaneType>();

  ListPaneType = ListPaneType;

  gridColor: string = '#64C2E6';
  floorColor: string = '#ACB4BB';

  constructor() {
  }

  ngOnInit() {
  }

  selectItem(listPaneType: ListPaneType): void {
    this.selectedListPane = listPaneType;
    if (listPaneType === ListPaneType.Grid) {
      this.gridColor = '#64C2E6';
      this.floorColor = '#ACB4BB';
      this.selectedItem.emit(ListPaneType.Grid);
    } else {
      this.gridColor = '#ACB4BB';
      this.floorColor = '#64C2E6';
      this.selectedItem.emit(ListPaneType.Floor);
    }
  }

  onHoverItem(listPaneType: ListPaneType): void {
    if (this.selectedListPane !== listPaneType) {
      listPaneType === ListPaneType.Grid ? this.gridColor = '#868D94' : this.floorColor = '#868D94';
    }
  }

  onMouseoutItem(listPaneType: ListPaneType): void {
    if (this.selectedListPane !== listPaneType) {
      listPaneType === ListPaneType.Grid ? this.gridColor = '#ACB4BB' : this.floorColor = '#ACB4BB';
    }
  }
}
